import {gql} from '@apollo/client'

// Whether the calling agent may self-provision Twilio numbers + remaining headroom.
export const TWILIO_PROVISIONING_STATUS = gql`
  query TwilioProvisioningStatus {
    twilioProvisioningStatus {
      enabled
      maxNumbers
      activeCount
      remaining
    }
  }
`

// The agent's active provisioned numbers (personal Caller IDs).
export const MY_PROVISIONED_NUMBERS = gql`
  query MyProvisionedNumbers {
    myProvisionedNumbers {
      id
      e164
      areaCode
      friendlyName
      status
      trunkAttached
      didCreated
      isOutboundCid
      capabilities
      smsDefault
      created
      routeMode
      ownerName
      assignedUserId
      assignedUserName
      assignedGroupId
      assignedGroupName
    }
  }
`

// Numbers the agent may present as outbound Caller ID: their ASSIGNED personal
// numbers + the numbers of the groups they belong to. Same set start_call accepts.
export const MY_OUTBOUND_CID_NUMBERS = gql`
  query MyOutboundCidNumbers {
    myOutboundCidNumbers {
      id
      e164
      friendlyName
      status
      isOutboundCid
      routeMode
      assignedUserId
      assignedGroupId
      assignedGroupName
      assignedGroupIngroupId
    }
  }
`

// Active numbers the caller may (re)assign (own + supervised/admin scope).
export const ASSIGNABLE_NUMBERS = gql`
  query AssignableNumbers {
    assignableNumbers {
      id
      e164
      areaCode
      status
      isOutboundCid
      routeMode
      ownerId
      ownerName
      assignedUserId
      assignedUserName
      assignedGroupId
      assignedGroupName
    }
  }
`

// Groups + users the caller may assign a number TO (for the picker).
export const ASSIGNABLE_TARGETS = gql`
  query AssignableTargets {
    assignableTargets
  }
`

// Search Twilio's inventory for voice-capable numbers to buy. Read-only.
export const TWILIO_AVAILABLE_NUMBERS = gql`
  query TwilioAvailableNumbers($areaCode: String, $state: String, $country: String, $contains: String, $limit: Int) {
    twilioAvailableNumbers(areaCode: $areaCode, state: $state, country: $country, contains: $contains, limit: $limit) {
      phoneNumber
      friendlyName
      locality
      region
      areaCode
      voice
      sms
    }
  }
`
